import { toast } from "react-toastify";
import * as moment from "moment";

// custom pages
import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const qualityAnalyzerAPI = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAccessionDetailsAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/accession-details?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getErrorCategoriesAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/error-categories`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getErrorSummariesAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/error-summaries`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getActionableItemsAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/actionableItems`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function updateAccessionDetailsAPI(data) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/accession-details`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getMasterDataAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/master-data`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAccessionDetailsExport(body) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "User-Timezone": userTimeZone
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/report/accession-details`,
        obj
      );

      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json.message === "No data found.") {
            toast.error("No data found", { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const { startDate, endDate, modalityIds, practiceIds, radiologistIds } = body;
          const dateRange = startDate === endDate 
                    ? `${startDate}`  // If dates are the same, show only one date
                    : `${startDate} to ${endDate}`;

                    let filterString = '';
                    if (modalityIds || practiceIds || radiologistIds) {
                        const filters = [];
    
                        if (practiceIds && practiceIds.length > 0) {
                          filters.push(`Practice ${practiceIds.join(',')}`);
                      }

                      if (radiologistIds && radiologistIds.length > 0) {
                        filters.push(`Radiologist- ${radiologistIds.join(',')}`);
                    }
                        if (modalityIds && modalityIds.length > 0) {
                            filters.push(`Modality- ${modalityIds.join(',')}`);
                        }
                        
    
                        filterString = filters.length > 0 &&` - ${filters.join(',')}`;
                    }          
          link.setAttribute(
            "download",
            `Accession Details Report ${dateRange} ${filterString}
            .xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  async function getQualityAnalysisExport(body) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "User-Timezone": userTimeZone
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/report/quality-error-analysis`,
        obj
      );

      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json.message === "No data found.") {
            toast.error("No data found", { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const { startDate, endDate} = body;
          const dateRange = startDate === endDate 
                    ? `${startDate}`  // If dates are the same, show only one date
                    : `${startDate} to ${endDate}`;
    
          link.setAttribute(
            "download",
            `Quality Error Analysis Report ${dateRange} 
            .xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  async function getQualityAnalysisDetailedExport(body) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "User-Timezone": userTimeZone
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/report/quality-analysis-detailed`,
        obj
      );

      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json.message === "No data found.") {
            toast.error("No data found", { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const { startDate, endDate} = body;
          const dateRange = startDate === endDate 
                    ? `${startDate}`  // If dates are the same, show only one date
                    : `${startDate} to ${endDate}`;
    
          link.setAttribute(
            "download",
            `Quality Analysis Detailed Report ${dateRange} 
            .xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  async function getQualityCompletionExport(body) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "User-Timezone": userTimeZone
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/quality-analyzer/report/quality-completion`,
        obj
      );

      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json.message === "No data found.") {
            toast.error("No data found", { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const { startDate, endDate} = body;
          const dateRange = startDate === endDate 
                    ? `${startDate}`  // If dates are the same, show only one date
                    : `${startDate} to ${endDate}`;
    
          link.setAttribute(
            "download",
            `Quality Completion Report ${dateRange} 
            .xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getAccessionDetailsAPI,
    getErrorCategoriesAPI,
    getErrorSummariesAPI,
    updateAccessionDetailsAPI,
    getMasterDataAPI,
    getAccessionDetailsExport,
    getActionableItemsAPI,
    getQualityAnalysisExport,
    getQualityAnalysisDetailedExport,
    getQualityCompletionExport
  };
};

export default qualityAnalyzerAPI;
